type InputmaskEvent = Pick<Event, 'target'> | null | undefined;

type InputmaskInstance = {
  unmaskedvalue?: () => string | number;
  userOptions?: {
    alias?: string;
  };
};

export type InputmaskTarget = EventTarget & {
  inputmask?: InputmaskInstance;
  value?: string;
  valueAsNumber?: number;
};

export function getInputmaskTarget(event: InputmaskEvent) {
  return event?.target as InputmaskTarget | null | undefined;
}

export function getInputmaskAlias(event: InputmaskEvent) {
  return getInputmaskTarget(event)?.inputmask?.userOptions?.alias;
}

export function getInputmaskUnmaskedValue(event: InputmaskEvent) {
  return getInputmaskTarget(event)?.inputmask?.unmaskedvalue?.();
}

/** A dollar-currency mask's value in whole cents; a typed zero stays 0, an empty or non-numeric field is undefined. */
export function getInputmaskCents(event: InputmaskEvent) {
  const unmasked = getInputmaskUnmaskedValue(event);
  if (unmasked === undefined || unmasked === '') return undefined;
  const dollars = Number(unmasked);
  return Number.isFinite(dollars) ? Math.round(dollars * 100) : undefined;
}
